import React from 'react';
import type { RequiresAccessibleLabel } from '@wix/da-a11y/pkg/typeHelpers';
import IconButton, {
  type Props as IconButtonProps,
} from '@wix/da-ds/pkg/Buttons/IconButton';

interface BaseProps extends Omit<IconButtonProps, 'size' | 'variant'> {}

type Props = RequiresAccessibleLabel<BaseProps>;

const ActionBarIconButton: React.FC<Props> = props => {
  return <IconButton size="medium" variant="main" {...props} />;
};

ActionBarIconButton.displayName = 'ActionBarIconButton';

export default ActionBarIconButton;
